module.exports = __webpack_public_path__ + "static/media/zapier-logomark.35703ff2.svg";